interface AlertProps {
  type: "success" | "failed" | "info";
  message: string;
  onClose?: () => void;
}

export const Alert = ({ type, message, onClose }: AlertProps) => {
  const palette =
    type === "success"
      ? "border-emerald-300 bg-emerald-50 text-emerald-800"
      : type === "info"
      ? "border-sky-300 bg-sky-50 text-sky-800"
      : "border-rose-300 bg-rose-50 text-rose-800";

  return (
    <div className={`rounded-xl border px-4 py-3 text-sm ${palette}`}>
      <div className="flex items-start justify-between gap-4">
        <p>{message}</p>
        {onClose ? (
          <button
            type="button"
            onClick={onClose}
            className="shrink-0 text-xs font-semibold uppercase tracking-wide"
          >
            Close
          </button>
        ) : null}
      </div>
    </div>
  );
};
